import { Box, BoxProps } from '@razorpay/blade/components';
import bgIllustration from 'assets/bg_illustration.svg';
import React from 'react';
import styled from 'styled-components';

export const FormWrapper = styled.form`
  display: grid;
  grid-template-rows: 1fr auto;
  height: 100%;
`;

export const IllustrationContainer = styled.div<{ noBgIllustration?: boolean }>`
  display: flex;
  width: 100%;
  padding: ${({ theme }) => theme.spacing[8]}px;
  background-image: ${({ noBgIllustration }) =>
    noBgIllustration ? 'none' : `url(${bgIllustration})`};
  background-size: contain;
  background-attachment: fixed;
  background-repeat: no-repeat;
`;

export const StepContentWrapper: React.FC<BoxProps & { noBgIllustration?: boolean }> = ({
  children,
  noBgIllustration = false,
  ...boxProps
}) => (
  <IllustrationContainer noBgIllustration={noBgIllustration}>
    <Box maxWidth="700px" width={{ base: '100%', m: '700px' }} marginX="auto" {...boxProps}>
      {children}
    </Box>
  </IllustrationContainer>
);
